app.service('productCardView', function (productArchive, main, searchResultCollector, autocompleteInfo, callback, broker, productSalesTabs, productCardConfig, log, console, socialBox, productCardPhotos, productCardSales, productCardPromotions, searchBox, productTabs, productForSale, productInteractionListener, modal, productPriceVariants, price) {
	var $productTop;

	function setEvents(){
		$('.attribute-name a', $productTop).click(function(){
			UA.pageInteraction('Słownik', 'Cecha - '+$.trim($(this).text())+' - '+config.groupName);
		});
		$('.attribute-value a', $productTop).click(function(){
			UA.pageInteraction('Słownik', 'Wartość  - '+$.trim($(this).text())+' - '+config.groupName);
		});
		$('.stars-rating a:not(.rating-count)', $productTop).click(function(){
			UA.pageInteraction('Opinie', 'Gwiazdki nad foto');
		});
		$('.stars-rating a.rating-count', $productTop).click(function(){
			UA.pageInteraction('Opinie', 'Gwiazdki nad foto - Tekst');
		});
		$('.stars-rating a.rating-count', $productTop).click(function(){
			UA.pageInteraction('Opinie', 'Gwiazdki nad foto - Tekst');
		});
		$('.js-product-charger-mark-details', $productTop).on('click', function(){
			modal.open($(this).data('modal-id'));
		});
		$('.product-photo a, .product-name a, .product-action a', '#successor-product').click(function(){
			UA.pageInteraction('Następnik', config.id);
		});
		$('.js-social-fb', $productTop).click(function(){
			log.recommendationsForAWS({
				productPlu: $productTop.data('plu'),
				eventCategory: 'Dodaj do FB',
				eventAction: 'Dodaj do FB'
			});
		});
		broker.on('PRODUCT_MENU_TAB_CHANGE', handleProductTabChange);
		broker.on('PRODUCT_PRICE_VARIANT_CHANGE', handleProductPriceChange);
	}
	function handleProductTabChange(e, props) {
		$productTop.attr('data-tab', props.nextTab);
	}
	function handleProductPriceChange(e, props) {
		if(props.productPrice) {
			const numberPrice = props.productPrice*1;
			const formattedProductPrice = price.format(props.productPrice);
			$('.product-prices-box .price-normal', $productTop).text(formattedProductPrice);
			$('.js-add-to-cart', $productTop).attr('data-custom-price', numberPrice);
		}
	}

	function setElements() {
		$productTop=$('#product-top');
	}

	function init() {
		config=productCardConfig.getData();
		autocompleteInfo.logResult('product', config);
		productInteractionListener.onProductCardView({
			id: config.id,
			plu: config.plu,
			groupId: config.groupId,
			groupName: config.groupName
		});

		if( $("#product-archive").length ){
 			productArchive.init();
		}else{
			searchResultCollector.init('product',config.title);
			setElements();
			setEvents();
			productCardPhotos.init();
			productCardSales.init();
			productForSale.init();
			productCardPromotions.init();  //incjalizacja /web-cached/cms-promotion-block-section.ltr dla eK
			socialBox.init('product');
		}
		log.visit({
			productId : config.id,
			productCode : config.plu,
			productsGroupId : config.groupId,
			productAvailabilityStatusCode : config.productAvailabilityStatusCode,
			keyword: searchBox.getKeyword() || undefined,
			status: config.status
		});
		log.recommendationsForAWS({
			productPlu: config.plu,
			eventCategory: 'KP',
			eventAction: 'Wejście na widok'
		});
		productTabs.init();
		productPriceVariants.init();
		if(config.outletView && config.outletCategories.length>0){
			productSalesTabs.setOutletCategory({
				productId: config.id,
				outletCategoryId: config.outletCategories[0].outletCategoryId,
				scroll: "tab",
				tab: "outlet"
			});
		}
	}
	main.onLoad(init);
});
